import React from "react";
import fieldProps from "./fieldProps";
import apiClient from '../../../../services/axios';
import { getUrl } from '../../../../services/api';

class AutocompleteCity extends React.Component {
  timeoutId = null;

  componentDidMount() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { types = ['(cities)'], country = "it" } = this.props;
    this.optionsAutocomplet = {
      language: 'it-IT',
      types,
    };
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  handleInputChange = (e) => {
    const { onChange } = this.props;
    const inputValue = e.target.value;

    onChange({ label: inputValue });

    if (inputValue.length < 2) {
      return;
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      if (!this.autocomplete) {
        this.autocomplete = new google.maps.places.Autocomplete(this.input, this.optionsAutocomplet);
        this.autocomplete.addListener('place_changed', this._fillInAddress);
      }
    }, 500);
  }

  _onBlur = () => {
    const { onChange } = this.props;
    if (this.input.value.trim() === '') {
      onChange(null);
    }
  }

  _fillInAddress = () => {
    const { onChange, itDetails } = this.props;
    const place = this.autocomplete.getPlace();
    let city = null;
    let prov = null;
    let country_code = null;
    let country = null;
    let city_long = null;
    let postal_code = null;

    const results = place.address_components || null;
    if (results) {
      city = place.address_components[0] && place.address_components[0].short_name || '';
      city_long = place.address_components[0] && place.address_components[0].long_name || '';
      results.forEach(item => {
        const comp = item;
        if (comp.types.indexOf("administrative_area_level_2") >= 0) {
          prov = comp.short_name || "";
        } else if (comp.types.indexOf("country") >= 0) {
          country_code = comp.short_name || "";
          country = comp.long_name || "";
        } else if (comp.types.indexOf('postal_code') >= 0) {
          postal_code = comp.long_name;
        }
      });

      const values = {
        code: null,
        country,
        countryCode: country_code,
        label: city_long,
        prov,
        cap: postal_code,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      onChange(values);

      if (itDetails && country_code === 'IT') {
        apiClient.get(getUrl('api/city-details'), { params: { cityLong: city_long, label: city, prov, postal_code } })
          .then(({ data }) => {
            if (data) {
              const { code, id_regione, provincia, cap } = data;
              onChange({
                ...values,
                code,
                region: id_regione,
                prov: provincia,
                cap,
              });
            }
          });
      }
    }
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { value, onChange, name } = this.props;

    return (
      <input
        name={name}
        onBlur={this._onBlur}
        className={"form-control input-sm"}
        onChange={this.handleInputChange}
        value={value}
        ref={input => { this.input = input }}
      />
    );
  }
}

export default fieldProps(AutocompleteCity);